import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Wrapper from './Wrapper';

ReactDOM.render(<Wrapper />, document.getElementById('root'));
